import Container from "Components/Container/Container";
import React from "react";
import { Link } from "react-router-dom";
const GetInTouch = () => {
  return (
    <div className=" border-b border-[#808080] py-6 bg-[#222]">
      <Container>
        <div className="flex flex-col gap-y-3 lg:flex-row lg:items-center lg:justify-between text-white ">
          <p className="text-lg">
            Call us on +971 4 346 8556 or fill in your details and have us call
            you back
          </p>
          <Link
            to={"/contact-us"}
            className="border border-white hover:bg-white hover:text-black transition ease-in duration-300 px-8 py-1 rounded-2xl w-max"
          >
            Get In Touch
          </Link>
        </div>
      </Container>
    </div>
  );
};

export default GetInTouch;
